export default {
  ExamStore: {
    ComposeTest: 'Soạn đề kiểm tra',
    Compose: 'Soạn đề',
    Upload: 'Tải lên',
    ChoosePeriod: 'Chọn kỳ đánh giá',
    ExamName: 'Tên bài kiểm tra',
    DoingTime: 'Thời gian làm bài',
    MaxPoint: 'Thang điểm',
    Coefficient: 'Hệ số',
    WarningCompleteCompose: 'Bạn cần hoàn thành soạn đề trước khi chuyển sang bước tiếp theo.',
    TemplateComposeThread: 'Soạn đề: {Title}',
    TemplateComposePoint: 'Cho điểm: {Title}',
    ValidatePointFail: 'Tổng điểm phải bằng số thang điểm đã chọn',
    Cancel: 'Hủy',
    MyThread: 'Đề của tôi',
    AssignedThread: 'Hội đồng phân công',
    SaveDraft: 'Lưu nháp',
    WarningChangeCancelCompose: 'Hủy bỏ quá trình soạn đề kiểm tra?',
    TotalPointTooHigh: 'Tổng điểm vượt quá thang điểm đã chọn',
    Point: 'Điểm',
    ComposeNewThread: 'Soạn đề mới',
    GivePoints: 'Cho điểm',
    AppearanceType: 'Hình thức thể hiện',
    DoByList: 'Làm bài theo danh sách',
    DoBySentence: 'Làm bài theo từng câu',
    SelectQuestion: 'Chọn đáp án đúng',
    FillQuestion: 'Điền từ',
    YesornoQuestion: 'Đúng sai',
    EssayQuestion: 'Tự luận',
    SaveSuccess: 'Lưu đề thi thành công.',
    ListExam: 'Danh sách bài kiểm tra',
    CreateExam: 'Tạo bài kiểm tra',
    TextSearch: 'Tìm kiếm',
    MyPost: 'Bài của tôi',
    ShareSchool: 'Chia sẻ trong trường',
    AssignComposing: 'Phân công soạn',
    DotAssignment: 'Phân công chấm',
    Detail: 'Chi tiết',
    CheckTimeFrame: 'Khung thời gian kiểm tra',
    TestSubject: 'Đề kiểm tra',
    OpenTime: 'Thời gian mở đề',
    CloseTime: 'Thời gian đóng đề',
    SubmitResult: 'Gửi kết quả Trắc nghiệm ngay sau khi HS làm bài',
    GradeSubject: 'Khối - Môn',
    ExamPeriodStatus: 'Trạng thái',
    StudentDoHomeWork: 'Học sinh làm bài',
    StudentJoin: 'Học sinh tham gia',
    StudentSubmit: 'Học sinh nộp bài',
    Happenning: 'Đang diễn ra',
    Draft: 'Đang soạn',
    NotHappend: 'Chưa diễn ra',
    InComming: 'Chờ mở đề',
    TheEnd: 'Kết thúc',
    AllPeriod: 'Tất cả đề kiểm tra',
    ConfirmDelete: 'Bạn có chắc chắn muốn xóa <b>{ExamStoreName}</b> không?',
    Continue: 'Tiếp tục',
    Finnish: 'Hoàn thành',
    StudentJoinList: 'Danh sách học sinh tham gia',
    ChooseClass: 'Chọn lớp',
    AllClass: 'Tất cả các lớp',
    Student: 'Học sinh',
    Class: 'Lớp',
    Birthday: 'Ngày sinh',
    ChooseTimePeriod: 'Chọn khung thời gian kiểm tra',
    ChooseTime: 'Chọn thời gian làm bài',
    ChooseExamSubject: 'Chọn đề kiểm tra',
    DeleteFail: 'Xoá đề thi thất bại, vui lòng thử lại',
    DeleteSuccess: 'Xóa đề thi thành công.',
    ListStudentClassroom: 'Danh sách học sinh',
    ChoseStudentClassroom: 'Đã chọn',
    ShortPoint: 'đ',
    WarningPointNotEqualZero: 'Điểm số câu <b>{QuestionsError}</b> phải lớn hơn 0',
    MessagePointNotEqualZero: 'Điểm số của câu hỏi phải lớn hơn 0',
    MessageBeforeSaveExamStore: 'Hội đồng sẽ nhận được đề thi sau khi bạn ấn Hoàn thành.<br/>Bạn có thể chỉnh sửa đề trước khi bài kiểm tra diễn ra.',

    PointTutorial: {
      ChangeQuestion: 'Di chuyển nhanh giữa các ô điểm'
    },
    DemoExam: 'Làm thử',
    CheckResult: 'Kiểm tra kết quả',
    EditNotify: 'Đáp án bạn chọn khác với đáp án đúng <br> Hãy chọn <strong>Chỉnh sửa</strong> nếu muốn thiết lập lại',
    ViewHint: 'Xem lời giải'
  }
}
